import { Link } from 'react-router-dom'
import { HubSpotMeetingEmbed } from '@/components/HubSpotMeetingEmbed'
import { SEO } from '@/components/seo'

const demoFeatures = [
  {
    icon: (
      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    ),
    text: '30-minute personalised session',
  },
  {
    icon: (
      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    text: '1-on-1 with a product expert',
  },
  {
    icon: (
      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
        <line x1="8" y1="21" x2="16" y2="21" />
        <line x1="12" y1="17" x2="12" y2="21" />
      </svg>
    ),
    text: 'Screen share & live Q&A',
  },
  {
    icon: (
      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      </svg>
    ),
    text: 'Tailored to your practice',
  },
]

export default function BookDemoPage() {
  return (
    <>
      <SEO
        title="Book a Demo - WealthSpace | AI Practice Management"
        description="Book a personalised WealthSpace demo. See how AI can transform your financial advice practice in just 30 minutes."
        keywords="WealthSpace demo, financial adviser software demo, AI practice management demo, book demo, WealthSpace trial"
        url="/book-demo"
      />

      {/* Hero */}
      <section className="pt-[60px] pb-10 px-6 relative z-[1]">
        <div className="max-w-[800px] mx-auto text-center animate-fade-in-up opacity-0 [animation-delay:0.1s] [animation-fill-mode:forwards]">
          <p className="text-sm font-semibold text-accent-teal tracking-[0.1em] uppercase mb-4">
            30-minute personalised demo
          </p>
          <h1 className="font-serif text-[clamp(32px,5vw,48px)] font-normal leading-[1.2] tracking-[-0.02em] mb-4">
            Book a <span className="text-accent-teal">call</span>
          </h1>
          <p className="text-[17px] text-brand-muted leading-[1.6] max-w-[500px] mx-auto">
            Choose a time that works for you. We'll tailor the demo to your practice.
          </p>
        </div>
      </section>

      {/* Booking Section */}
      <section className="px-6 pb-20 relative z-[1]">
        <div className="max-w-[700px] mx-auto animate-fade-in-up opacity-0 [animation-delay:0.2s] [animation-fill-mode:forwards]">
          {/* Features Banner */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 mb-6">
            {demoFeatures.map((feature, index) => (
              <div key={index} className="flex items-center gap-2 text-sm text-brand-muted">
                <span className="text-accent-teal">{feature.icon}</span>
                <span className="text-[13px]">{feature.text}</span>
              </div>
            ))}
          </div>

          {/* HubSpot Embed Card */}
          <div className="bg-[linear-gradient(145deg,rgba(255,255,255,0.03)_0%,rgba(255,255,255,0.01)_100%)] border border-white/[0.06] rounded-2xl overflow-hidden p-2 md:p-4">
            <HubSpotMeetingEmbed
              meetingUrl="https://meetings-eu1.hubspot.com/simon-smith5"
              className="min-h-[660px]"
            />
          </div>
        </div>
      </section>

      {/* Back Link */}
      <div className="text-center px-6 pb-16 relative z-[1]">
        <Link
          to="/get-started"
          className="inline-flex items-center gap-2 text-sm text-brand-subtle hover:text-brand-muted transition-colors"
        >
          <svg
            className="w-4 h-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Back to options
        </Link>
      </div>
    </>
  )
}
